import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, setBlockTracking as _setBlockTracking, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1a839ddc")
const _hoisted_1 = { class: "p-d-flex p-ai-center heading" }
const _hoisted_2 = { class: "datesCourse p-col-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Fecha de inicio ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" hasta ")
const _hoisted_6 = {
  key: 0,
  class: "studentsState p-col-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock p-mr-1" }, null, -1)
const _hoisted_8 = { class: "studentsState p-col-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Cantidad de estudiantes ")
const _hoisted_11 = {
  key: 1,
  class: "p-grid"
}
const _hoisted_12 = { class: "p-sm-12 p-md-12 p-lg-3" }
const _hoisted_13 = { class: "p-grid p-ai-end" }
const _hoisted_14 = { class: "p-col-12" }
const _hoisted_15 = { class: "custom-chart-labels-container p-text-center" }
const _hoisted_16 = { class: "percentage-completed" }
const _hoisted_17 = { class: "percentage" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "completed" }, "COMPLETADO", -1)
const _hoisted_19 = { class: "classes-of" }
const _hoisted_20 = { class: "p-col-12" }
const _hoisted_21 = { class: "p-sm-12 p-md-12 p-lg-9" }
const _hoisted_22 = { class: "p-grid" }
const _hoisted_23 = { class: "p-col-7" }
const _hoisted_24 = { class: "p-col-5 p-pl-5 p-pr-5" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeneralPerformanceCard = _resolveComponent("GeneralPerformanceCard")!
  const _component_DoughnutChartCard = _resolveComponent("DoughnutChartCard")!
  const _component_PerformanceGeneralInfoCard = _resolveComponent("PerformanceGeneralInfoCard")!
  const _component_PerformanceStaffInfo = _resolveComponent("PerformanceStaffInfo")!
  const _component_CourseCommentsBox = _resolveComponent("CourseCommentsBox")!
  const _component_ToolLinks = _resolveComponent("ToolLinks")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("strong", null, _toDisplayString(_ctx.DateTime.fromISO(_ctx.course.calendar.start).toFormat('dd/MM')), 1),
        _hoisted_5,
        _createElementVNode("strong", null, _toDisplayString(_ctx.DateTime.fromISO(_ctx.course.calendar.end).toFormat('dd/MM')), 1)
      ]),
      (_ctx.course.calendar.hours && _ctx.course.calendar.daysOfTheWeekNames)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.calendar.daysOfTheWeekNames, (day, i) => {
              return (_openBlock(), _createElementBlock("strong", {
                class: _normalizeClass({'p-mr-1': _ctx.isLastItem(i, (_ctx.course.calendar.daysOfTheWeekNames))}),
                key: day
              }, _toDisplayString(_ctx.isLastItem(i, (_ctx.course.calendar.daysOfTheWeekNames))
            ? day
            : `${day}, `), 3))
            }), 128)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.course.calendar.hours?.get(_ctx.CourseHours.Start)) + " - " + _toDisplayString(_ctx.course.calendar.hours?.get(_ctx.CourseHours.End)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("strong", null, _toDisplayString(_ctx.course.studentCapacity.currentStudents) + "/" + _toDisplayString(_ctx.course.studentCapacity.max !== 0 ? _ctx.course.studentCapacity.max : 'Sin asignar máxima capacidad'), 1)
      ])
    ]),
    (_ctx.courseStatus === _ctx.CourseStatus.Finished)
      ? (_openBlock(), _createBlock(_component_GeneralPerformanceCard, {
          key: 0,
          contentRating: _ctx.ClassFeedbackSummary.getAverage(_ctx.summaries)?.contentSummary?.value,
          teacherRating: _ctx.ClassFeedbackSummary.getAverage(_ctx.summaries)?.teacherSummary?.value,
          tutorRating: _ctx.ClassFeedbackSummary.getAverage(_ctx.summaries)?.tutorSummary?.value,
          teachersWithRating: _ctx.ClassFeedbackSummary.getStaffNamesAndAverage(_ctx.summaries, _ctx.PersonRoles.Teacher),
          tutorsWithRating: _ctx.ClassFeedbackSummary.getStaffNamesAndAverage(_ctx.summaries, _ctx.PersonRoles.Tutor),
          teachersValue: _ctx.avgRate.teacherSummary.value,
          tutorsValue: _ctx.avgRate.tutorSummary.value,
          value: _ctx.avgRate.contentSummary.value,
          lastValue: _ctx.lastContentRating,
          variation: _ctx.lastContentVariation,
          courseProgressData: _ctx.courseProgressData,
          course: _ctx.course,
          students: _ctx.students
        }, null, 8, ["contentRating", "teacherRating", "tutorRating", "teachersWithRating", "tutorsWithRating", "teachersValue", "tutorsValue", "value", "lastValue", "variation", "courseProgressData", "course", "students"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[0] || (
                  _setBlockTracking(-1),
                  _cache[0] = _createVNode(_component_DoughnutChartCard, {
                    class: "course-progress-chart-card",
                    title: "Progreso del curso",
                    titleAlign: "center",
                    chartData: _ctx.courseProgressData,
                    chartColors: [
                    _ctx.CSSColors.LightblueBrain,
                    _ctx.CSSColors.PrimaryColor
                  ],
                    maintainAspectRatio: false
                  }, {
                    labels: _withCtx(({ values }) => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.truncate((values[0] / (values[0] + values[1])) * 100, 2)) + "%", 1),
                          _hoisted_18
                        ]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(values[0]) + "/" + _toDisplayString(values[0] + values[1]), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["chartData", "chartColors"]),
                  _setBlockTracking(1),
                  _cache[0]
                )
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_PerformanceGeneralInfoCard, {
                  lastValue: _ctx.summary?.contentSummary?.rating?.value,
                  value: _ctx.avgRate?.contentSummary?.value,
                  variation: _ctx.summary?.contentSummary?.rating?.variation
                }, null, 8, ["lastValue", "value", "variation"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_PerformanceStaffInfo, {
              teachersValue: _ctx.avgRate?.teacherSummary?.value,
              tutorsValue: _ctx.avgRate?.tutorSummary?.value,
              tutorsSummary: _ctx.tutorssSummary,
              teachersSummary: _ctx.teachersSummary
            }, null, 8, ["teachersValue", "tutorsValue", "tutorsSummary", "teachersSummary"])
          ])
        ])),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_CourseCommentsBox, {
          courseId: _ctx.course._id,
          onOnSave: _ctx.handleSaveComment,
          comments: _ctx.comments,
          loading: _ctx.loadingComments
        }, null, 8, ["courseId", "onOnSave", "comments", "loading"])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_ToolLinks, {
          slack: _ctx.slackLink,
          sharedFolder: _ctx.sharedFolderLink,
          teacherFolder: _ctx.teacherFolderLink
        }, null, 8, ["slack", "sharedFolder", "teacherFolder"])
      ])
    ])
  ], 64))
}